import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black pe-0" }
const _hoisted_16 = {
  class: "dropdown-menu dropdown-block",
  style: {"position":"absolute","inset":"0px auto auto 0px","margin":"0px","transform":"translate(267px, 305px)"},
  "data-popper-placement": "bottom-start"
}
const _hoisted_17 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddPermissionModal = _resolveComponent("AddPermissionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddPermission'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
              _createElementVNode("a", {
                class: "btn btn-primary text-black",
                href: "#",
                "data-bs-toggle": "modal",
                "data-bs-target": "#AddPermissionModal"
              }, [
                _createElementVNode("i", { class: "fa fa-plus-circle" }),
                _createTextVNode(" Ajouter une permission ")
              ], -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black",
              placeholder: "Rechercher un privilege"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-black transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Nom "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Description "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Rôle "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "DATE DE CREATION "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
                }, "Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (permission, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(permission.nom), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(permission.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.rolePermissions, (rolePermission, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "text-center"
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (rolePermission.role)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(rolePermission.role.description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.format_date(permission.createdAt)), 1),
                  _createElementVNode("td", _hoisted_15, [
                    _cache[8] || (_cache[8] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary text-black",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_16, [
                      (_ctx.checkPermission('EditPermission'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            _createElementVNode("a", {
                              class: "text-black",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.moddifier(permission))
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "fa fa-pencil lh-2 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Modifier ")
                            ]), 8, _hoisted_18)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('DeletePermission'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createElementVNode("a", {
                              class: "text-black",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.suppression(permission.id,_ctx.permissions,'permissions',`la permission ${permission.nom}`))
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-2 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Supprimer ")
                            ]), 8, _hoisted_20)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddPermissionModal, {
      onGetAllPermissions: _ctx.getAllPermissions,
      id: _ctx.idpermission,
      onOpenmodal: _ctx.showModalEdite,
      onClose: _ctx.recharger,
      onRefreshPermissions: _ctx.refreshPermissions
    }, null, 8, ["onGetAllPermissions", "id", "onOpenmodal", "onClose", "onRefreshPermissions"])
  ], 64))
}